import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { axiosPublic } from 'app/utils';
import type { Envelope } from 'app/utils/api-envelope';

async function requestPasswordReset(username: string): Promise<void> {
  const { data } = await axiosPublic.post<Envelope<{ msg: string }>>('/passwordreset', {
    username,
  });
  if (data.error) throw new Error(data.error.text || data.error.message || 'Request failed');
}

export function useRequestPasswordReset(): UseMutationResult<void, Error, string> {
  return useMutation<void, Error, string>({
    mutationFn: (username) => requestPasswordReset(username),
    meta: {
      errorMessage: 'Unable to send the reset email. Please try again.',
    },
  });
}
